import { FC, ReactNode } from 'react'

import { Label } from '@inno-ui/label'
import { Toggle, ToggleSizes } from '@inno-ui/toggle'

import styles from './PreferenceToggleField.module.scss'

type PreferenceToggleFieldProps = {
  label: string
  hint: ReactNode
  checked: boolean
  onChange: (checked: boolean) => void
}

export const PreferenceToggleField: FC<PreferenceToggleFieldProps> = ({
  label,
  hint,
  checked,
  onChange
}) => {
  return (
    <div className={styles.preferenceSection}>
      <div className={styles.fieldHeader}>
        <Label label={label} hintZIndex={1001} hint={hint} />
      </div>
      <Toggle size={ToggleSizes.S} checked={checked} onChange={onChange} />
    </div>
  )
}
